const indexBy = (arr, key) => arr.reduce((memo, v) => ({ ...memo, [v[key]]: v }), {});
export default indexBy;
